import initIframe from './iframe';

document.querySelectorAll('.video__player[data-url]')
  .forEach(($player) => {
    const $poster = $player.querySelector('.video__poster');
    const $posterButton = $poster.querySelector('.video__poster-button');
    if ($posterButton) {
      $posterButton.addEventListener('click', () => {
        initIframe($player);
        $player.removeChild($poster);
      });
    }
  });
